import type { UiProject } from '@nightshift/ui-types';

/**
 * "All projects", or a chosen set: agent token access on Connect and a machine's project scope
 * on Machines. Selections are project slugs in the order the person ticked them.
 */
export function ProjectAccessPicker({
  projects,
  allProjects,
  slugs,
  disabled,
  onChange,
}: {
  projects: UiProject[];
  allProjects: boolean;
  slugs: string[];
  disabled?: boolean;
  onChange: (next: { allProjects: boolean; slugs: string[] }) => void;
}) {
  return (
    <div className="profiles-checks">
      <label className="profiles-check">
        <input
          type="checkbox"
          checked={allProjects}
          disabled={disabled}
          onChange={(event) => onChange({ allProjects: event.target.checked, slugs })}
        />
        <span>All projects</span>
      </label>
      {projects.map((project) => (
        <label key={project.slug} className="profiles-check">
          <input
            type="checkbox"
            checked={allProjects || slugs.includes(project.slug)}
            disabled={disabled || allProjects}
            onChange={() => {
              const next = slugs.includes(project.slug)
                ? slugs.filter((slug) => slug !== project.slug)
                : [...slugs, project.slug];
              onChange({ allProjects: false, slugs: next });
            }}
          />
          <span>{project.name}</span>
        </label>
      ))}
      {projects.length === 0 ? <p className="sheet-note">No projects registered yet.</p> : null}
    </div>
  );
}
